import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { concat } from 'rxjs';
import { GroupBase } from '../../../models/blueprint.model';
import { ReportView } from '../../../models/report.model';
import { TemplateField, LovValues } from '../../../models/template.model';
import { ReportExportViewService } from '../../../report-export-view.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { Contact, CONTACT_NAME_TYPES } from './dynamic-contacts.model';
import { SelectContactsDialogComponent } from './select-contacts/select-contacts.component';
import { SelectItem } from 'primeng/api/selectitem';

function arrayComparerFactory(otherArray: any[]) {
  return current => {
    const differentElements = otherArray.filter(otherElement => otherElement === current);
    return differentElements.length === 0;
  };
}
@Component({
  selector: 'rep-dynamic-contacts',
  templateUrl: './dynamic-contacts.component.html',
  styleUrls: ['./dynamic-contacts.component.scss'],
  standalone: false,
})
export class DynamicContactsComponent implements OnInit, OnChanges {
  //TECH DEBT (Sanjay): handle contacts based on contactGroups from blueprint
  @Input() contactGroups: GroupBase<TemplateField>[];
  @Input() currentView: ReportView;
  @Input() reportId: number;

  contactFields: TemplateField[];
  contactField: TemplateField;
  contactInfo: Contact[] = [];
  phoneCatalog: SelectItem[] = [];
  selectedPhone: string;
  nameCatalog = CONTACT_NAME_TYPES;
  selectedName: string;
  selectedContact: Contact;

  constructor(
    private notificationService: NotificationService,
    private reportExportViewService: ReportExportViewService
  ) {}

  ngOnInit() {
    this.getContacts();
    this.getPhoneOptions();
  }

  ngOnChanges({ currentView, contactGroups }: SimpleChanges) {
    if ((!!currentView && !!currentView.currentValue) || (!!contactGroups && !!contactGroups.currentValue)) {
      this.contactFields = []
        .concat(...(this.contactGroups || []).map(group => group.fields))
        .sort((a, b) => a.options.headerSortOrder - b.options.headerSortOrder);
    }
  }

  editContacts() {
    this.notificationService
      .openDialog<number[]>(
        SelectContactsDialogComponent,
        {
          selectedContacts: this.contactInfo.map(a => a.id),
        },
        { panelClass: 'table-modals' }
      )
      .subscribe(contacts => {
        if (contacts) {
          const savedContacts = this.contactInfo.map(contact => contact.id);
          const addContacts = contacts.filter(arrayComparerFactory(savedContacts));
          const removeContacts = savedContacts.filter(arrayComparerFactory(contacts));
          let request$ = [];
          if (removeContacts.length > 0) {
            request$.push(this.reportExportViewService.removeContact(this.reportId, removeContacts));
          }
          if (addContacts.length > 0) {
            request$.push(this.reportExportViewService.addContact(this.reportId, addContacts));
          }
          if (request$.length > 0) {
            // restricting addition of contacts if removal of contacts fail.
            const serialRequest$ = request$.length === 2 ? concat(...request$) : request$[0];
            serialRequest$.subscribe(() => {
              this.getContacts();
            });
          }
        }
      });
  }

  removeContact(contactId: number) {
    this.reportExportViewService.removeContact(this.reportId, [contactId]).subscribe(() => {
      this.getContacts();
    });
  }

  getContacts() {
    this.reportExportViewService.getContacts(this.reportId).subscribe(result => {
      if (result) {
        this.contactInfo = result;
      }
    });
  }

  private getPhoneOptions() {
    this.reportExportViewService.getLovValues('/lookup/ref?query=phone').subscribe((phoneOptions: LovValues[]) => {
      this.phoneCatalog = (phoneOptions || []).map(phone => ({
        label: phone.key,
        value: phone.value,
      })) as SelectItem[];
    });
  }
  editNamePhoneContact(contact: Contact) {
    this.selectedContact = contact;
  }
}
